const ProductBrandInitialValues = (showData) => ({
  brand_ids: showData?.data?.brands?.map((brand) => brand.id) || [],
});

export default ProductBrandInitialValues;
